const WIDGET_ANALYTICS_EVENTS = {
    TI_MODEL: "ti_model",
    PRE_STATE: "pre_state",
    PRE_PRICE: "pre_price",
    IMEI: "imei",
    ADD_PHOTO: "add_photo",
    PHOTO_ASSESSMENT: "photo_assessment",
    ASSESSMENT_RESULT: "assessment_result",
    PERSONAL_DATA: "personal_data",
    AGREEMENT: "agreement",
    ADD_TO_CART: "add_to_cart",
    PICKUP_ADDRESS: "pickup_address",
} as const;

export default WIDGET_ANALYTICS_EVENTS;
